<template>
  <div class="insured-dialog-form change-info" :class="{ 'change-info--multi': displayFields.length > 4 }">
    <div
      v-for="field in displayFields"
      :key="field.key"
      class="info-block"
    >
      <div class="label-row">
        <h6 class="label">{{ field.label }}</h6>
      </div>
      <div class="value-row">
        <template v-if="info[field.old] !== undefined && info[field.old] !== null">
          <span class="old-value">{{ getValue(info[field.old], field.type) }}</span>
          <i class="bi bi-arrow-right arrow"></i>
        </template>
        <span class="new-value">{{ getValue(info[field.new], field.type) }}</span>
      </div>
    </div>

    <div v-if="info.descr" class="notes-block">
      <h6 class="label">{{ $t("commonNotes") }}</h6>
      <div class="note-text">{{ info.descr }}</div>
    </div>

    <div v-if="info.statusNote" class="notes-block">
      <h6 class="label">{{ $t("requestDecisionNote") }}</h6>
      <div class="note-text">{{ info.statusNote }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fields() {
      return [
        { key: "pin", label: "PIN", new: "pin", old: "oldPin" },
        { key: "lastName", label: this.$t("commonLastName"), new: "lastName", old: "oldLastName" },
        { key: "firstName", label: this.$t("commonName"), new: "firstName", old: "oldFirstName" },
        { key: "middleName", label: this.$t("commonMiddleName"), new: "middleName", old: "oldMiddleName" },
        { key: "sex", label: this.$t("commonSex"), new: "sex", old: "oldSex", type: "sex" },
        { key: "dob", label: this.$t("commonBirthDate"), new: "dateOfBirthStr", old: "oldDateOfBirthStr" },
        { key: "phone", label: this.$t("commonPhone"), new: "phoneMobile", old: "oldPhone" },
        { key: "address", label: this.$t("commonAddress"), new: "address", old: "oldAddress" },
        { key: "status", label: this.$t("commonStatus"), new: "employeeStatusName", old: "oldEmployeeStatusName" },
        { key: "program", label: this.$t("commonProgram"), new: "groupName", old: "oldGroupName" },
        { key: "start", label: this.$t("insuredAcceptDate"), new: "startDateStr", old: "oldStartDateStr" },
        { key: "end", label: this.$t("insuredCancelDate"), new: "endDateStr", old: "oldEndDateStr" }
      ];
    },
    changedFields() {
      return this.fields.filter(
        (field) => !this.isEqual(this.info[field.new], this.info[field.old])
      );
    },
    displayFields() {
      if (this.changedFields.length > 0) {
        return this.changedFields;
      }
      return this.fields.filter(
        (field) => this.info[field.new] != null && this.info[field.new] !== ""
      );
    },
  },
  methods: {
    isEqual(newVal, oldVal) {
      return newVal == null || newVal === oldVal;
    },
    getValue(value, type) {
      if (!value) return this.$t("commonNotAvailable");
      if (type === "sex") return value === "k" ? this.$t("commonFemale") : this.$t("commonMale");
      return value;
    }
  }
};
</script>

<style scoped>
.change-info {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.85rem;
}

.change-info:not(.change-info--multi) {
  max-width: 520px;
  margin: 0 auto;
}

.change-info--multi {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.info-block {
  background: var(--account-dialog-bg);
  border-radius: 8px;
  padding: 0.85rem 1rem;
  margin-bottom: 0;
  border: 1px solid var(--account-insurance-border);
  box-shadow: none;
}

.label {
  font-size: 0.75rem;
  font-weight: 650;
  color: var(--account-form-section-title);
  margin-bottom: 0.45rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.value-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.55rem;
  font-size: 0.9rem;
}

.old-value {
  color: var(--app-text);
  text-decoration: line-through;
  background: var(--app-surface-muted);
  padding: 0.25rem 0.5rem;
  border-radius: 0.45rem;
}

.new-value {
  color: #176b36;
  font-weight: 600;
  background: color-mix(in srgb, #22c55e 16%, var(--app-surface));
  padding: 0.25rem 0.5rem;
  border-radius: 0.45rem;
}

.arrow {
  color: var(--bs-success);
  font-size: 1rem;
}

.notes-block {
  grid-column: 1 / -1;
  background: var(--app-surface-muted);
  border: 1px solid var(--app-border);
  border-radius: 0.85rem;
  padding: 1rem;
  margin-top: 0.15rem;
}

.note-text {
  background: var(--app-surface);
  border: 1px dashed var(--app-border-strong);
  padding: 0.75rem 1rem;
  border-radius: 0.65rem;
  font-size: 0.875rem;
  color: var(--app-text);
  line-height: 1.5;
}

@media (max-width: 767.98px) {
  .change-info--multi {
    grid-template-columns: 1fr;
  }
}
</style>
